import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeCommercial } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeCommercial} />; }
